import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { Image, initializeIcons, loadTheme, mergeStyles, registerIcons } from '@fluentui/react';
import { initializeFileTypeIcons } from '@fluentui/react-file-type-icons';
import * as serviceWorker from './serviceWorker';
import ContextWrapper from './contexts/ContextWrapper';
import MsalAuthProvider from './contexts/MsalContext';
import { AuthProvider } from './contexts/AuthContext';
import { CoboltTheme } from './helpers/Themes';
import './index.css';
import ImageVaultLogo from './assets/imagevault.svg';
import UnsplashLogo from './assets/unsplash.svg';

// Inject some global styles
mergeStyles({
	selectors: {
		':global(body), :global(html), :global(#root)': {
			margin: 0,
			padding: 0,
			height: '100%'
		}
	}
});


initializeIcons();
initializeFileTypeIcons()
loadTheme(CoboltTheme);

registerIcons({
	icons: {
		'ImageVault': <Image alt='ImageVault Logo' src={ImageVaultLogo} />,
		'Unsplash': <Image alt='Unsplash Logo' src={UnsplashLogo} />,
	},
});

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
	<React.StrictMode>
		<Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
			<MsalAuthProvider>
				<AuthProvider>
					<ContextWrapper>
						<App />
					</ContextWrapper>
				</AuthProvider>
			</MsalAuthProvider>
		</Router>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
